import { useContext } from 'react';
import { DataContext } from '@visx/xychart';

interface UseReferenceLineSetupReturn {
  // oxlint-disable-next-line typescript/no-explicit-any
  context: any;
}

/**
 * Custom hook that provides visx DataContext for reference lines.
 * No registration needed - reference line metadata is derived from referenceLineData prop!
 */
export function useReferenceLineSetup(): UseReferenceLineSetupReturn {
  const context = useContext(DataContext);

  return {
    context,
  };
}
